const CountryListTypes = {
	FETCH_COUNTRIES_START: 'FETCH_COUNTRIES_START',
	FETCH_COUNTRIES_SUCCESS: 'FETCH_COUNTRIES_SUCCESS',
	FETCH_COUNTRIES_FAILURE: 'FETCH_COUNTRIES_FAILURE',
};
export default CountryListTypes;
